'use client'
import { useContext } from 'react'
import { clientContext } from './ProviderClient'

function useClientContext(){
	return useContext(clientContext)
}

export { useClientContext }